import { removeClass, addClass, extend, EventHandler } from '@syncfusion/ej2-base';
import { closest, classList, isNullOrUndefined } from '@syncfusion/ej2-base';
import { Grid } from '../base/grid';
import { parents, getUid, appendChildren, isComplexField, getObject } from '../base/util';
import * as events from '../base/constant';
import { AriaService } from '../services/aria-service';
import { Row } from '../models/row';
import { Cell } from '../models/cell';
import { CellType } from '../base/enum';
import * as literals from '../base/string-literals';
/**
 * The `DetailRow` module is used to handle detail template and hierarchy Grid operations.
 */
export class DetailRow {
    /**
     * Constructor for the Grid detail template module
     *
     * @param {IGrid} parent - specifies the IGrid
     * @param {ServiceLocator} locator - specifes the serviceLocator
     * @hidden
     */
    constructor(parent, locator) {
        //Internal variables
        this.aria = new AriaService();
        this.childRefs = [];
        this.parent = parent;
        this.serviceLocator = locator;
        this.focus = locator.getService('focus');
        this.addEventListener();
    }
    /**
     * @returns {void}
     * @hidden
     */
    addEventListener() {
        if (this.parent.isDestroyed) {
            return;
        }
        EventHandler.add(this.parent.element, 'auxclick', this.auxilaryclickHandler, this);
        this.parent.on(events.click, this.clickHandler, this);
        this.parent.on(events.destroy, this.destroy, this);
        this.parent.on(events.keyPressed, this.keyPressHandler, this);
        this.parent.on(events.expandChildGrid, this.expand, this);
        this.parent.on(events.columnVisibilityChanged, this.refreshColSpan, this);
        this.parent.on(events.destroy, this.destroyChildGrids, this);
        this.parent.on(events.destroyChildGrid, this.destroyChildGrids, this);
        this.parent.on(events.destroy, this.detachDetailTemplate, this);
        this.parent.on(events.detachDetailTemplate, this.detachDetailTemplate, this);
    }
    clickHandler(e) {
        if ((e.target.classList.contains('e-icon-grightarrow') || e.target.classList.contains('e-icon-gdownarrow'))
            && !this.parent.allowGrouping) {
            e.preventDefault();
        }
        this.toogleExpandcollapse(closest(e.target, 'td'), e);
    }
    auxilaryclickHandler(e) {
        if ((e.target.classList.contains('e-icon-grightarrow') || e.target.classList.contains('e-icon-gdownarrow'))
            && !this.parent.allowGrouping && (e.button === 1)) {
            e.preventDefault();
        }
    }
    toogleExpandcollapse(target, event) {
        this.l10n = this.serviceLocator.getService('localization');
        const gObj = this.parent;
        const table = this.parent.getContentTable();
        const lastrowIdx = this.parent.getCurrentViewRecords().length - 1;
        const parent = 'parentDetails';
        let childGrid;
        const isExpanded = target && target.classList.contains('e-detailrowcollapse');
        if (!(target && (target.classList.contains('e-detailrowcollapse') || target.classList.contains('e-detailrowexpand')))
            || (target && target.classList.contains('e-masked-cell'))) {
            return;
        }
        const tr = target.parentElement;
        const uid = tr.getAttribute('data-uid');
        const rowObj = gObj.getRowObjectFromUID(uid);
        if (isNullOrUndefined(rowObj)) {
            return;
        }
        let needToRefresh = false;
        const nextRow = this.parent.getContentTable().querySelector(literals.tbody).children[tr.rowIndex + 1];
        if (target.classList.contains('e-detailrowcollapse')) {
            const data = rowObj.data;
            const expandArgs = {
                rowData: data, parentRow: target.closest('tr'), cancel: false, detailRow: this.isDetailRow(nextRow) ? nextRow : null
            };
            if (!isNullOrUndefined(event)) {
                expandArgs.event = event;
            }
            if (!isNullOrUndefined(gObj.childGrid)) {
                expandArgs.childGrid = gObj.childGrid;
                if (this.isDetailRow(nextRow)) {
                    const gridElement = nextRow.querySelector('.e-grid');
                    expandArgs.childGridInstance = gridElement ?
                        gridElement.ej2_instances[0] : null;
                }
            }
            gObj.trigger(events.detailExpand, expandArgs);
            if (expandArgs.cancel) {
                return;
            }
            if (this.isDetailRow(nextRow)) {
                nextRow.style.display = '';
                gObj.notify(events.detailStateChange, { data: data,
                    childGrid: gObj.childGrid, detailElement: target, isExpanded: isExpanded });
                needToRefresh = true;
            }
            else if (gObj.getDetailTemplate() || gObj.childGrid) {
                const rowId = getUid('grid-row');
                const detailRow = this.parent.createElement('tr', { className: 'e-detailrow', attrs: { 'data-uid': rowId, role: 'row' } });
                const detailCell = this.parent.createElement('th', { className: 'e-detailcell', attrs: { 'scope': 'col', role: 'columnheader' } });
                let colSpan = this.parent.getVisibleColumns().length;
                if (this.parent.allowRowDragAndDrop) {
                    colSpan++;
                }
                detailCell.setAttribute('colspan', colSpan.toString());
                const row = new Row({
                    isDataRow: true,
                    isExpand: true,
                    uid: rowId,
                    isDetailRow: true,
                    cells: [new Cell({ cellType: CellType.Indent }), new Cell({ isDataCell: true, visible: true })]
                });
                row.parentUid = rowObj.uid;
                for (let i = 0, len = gObj.groupSettings.columns.length; i < len; i++) {
                    detailRow.appendChild(this.parent.createElement('td', { className: 'e-indentcell' }));
                    row.cells.unshift(new Cell({ cellType: CellType.Indent }));
                }
                detailRow.appendChild(this.parent.createElement('th', { className: 'e-detailindentcell', attrs: { 'scope': 'col' } }));
                detailRow.appendChild(detailCell);
                tr.parentNode.insertBefore(detailRow, tr.nextSibling);
                let isReactCompiler;
                let isReactChild;
                if (gObj.detailTemplate) {
                    isReactCompiler = this.parent.isReact && typeof (gObj.detailTemplate) !== 'string' &&
                        !(gObj.detailTemplate.prototype && gObj.detailTemplate.prototype.CSPTemplate);
                    isReactChild = this.parent.parentDetails && this.parent.parentDetails.parentInstObj &&
                        this.parent.parentDetails.parentInstObj.isReact;
                    const isReactPrintGrid = this.parent.printGridParent && this.parent.printGridParent.isReact;
                    const detailTemplateID = gObj.element.id + 'detailTemplate';
                    if (isReactCompiler || isReactChild || isReactPrintGrid) {
                        gObj.getDetailTemplate()(data, gObj, 'detailTemplate', detailTemplateID, null, null, detailCell);
                        this.parent.renderTemplates(function () {
                            gObj.trigger(events.detailDataBound, { detailElement: detailCell, data: data, childGrid: childGrid });
                        });
                    }
                    else {
                        appendChildren(detailCell, gObj.getDetailTemplate()(data, gObj, 'detailTemplate', detailTemplateID, undefined, undefined, undefined, this.parent['root']));
                    }
                }
                else {
                    childGrid = new Grid(this.getGridModel(gObj, rowObj, gObj.printMode));
                    childGrid.height = gObj.enableInfiniteScrolling && childGrid.height === 'auto' ? 300 : childGrid.height;
                    childGrid.root = gObj.root ? gObj.root : gObj;
                    this.childRefs.push(childGrid);
                    if (childGrid.query) {
                        childGrid.query = childGrid.query.clone();
                    }
                    childGrid[`${parent}`] = {
                        parentID: gObj.element.id,
                        parentPrimaryKeys: gObj.getPrimaryKeyFieldNames(),
                        parentKeyField: gObj.childGrid.queryString,
                        parentKeyFieldValue: gObj.childGrid.queryString && isComplexField(gObj.childGrid.queryString) ?
                            getObject(gObj.childGrid.queryString, data) : data[gObj.childGrid.queryString],
                        parentRowData: data
                    };
                    if (gObj.isReact || gObj.isVue) {
                        childGrid.parentDetails.parentInstObj = gObj;
                    }
                    else if (gObj.parentDetails && gObj.parentDetails.parentInstObj && (gObj.parentDetails.parentInstObj.isReact
                        || gObj.parentDetails.parentInstObj.isVue)) {
                        childGrid.parentDetails.parentInstObj = gObj.parentDetails.parentInstObj;
                    }
                    if (gObj.printGridParent && gObj.printGridParent.isReact) {
                        childGrid.printGridParent = gObj.printGridParent;
                    }
                    childGrid.isLegacyTemplate = gObj.isReact
                        || gObj.isLegacyTemplate;
                    if (gObj.isPrinting) {
                        childGrid.isPrinting = true;
                        childGrid.on(events.contentReady, this.promiseResolve(childGrid), this);
                        childGrid.on(events.onEmpty, this.promiseResolve(childGrid), this);
                    }
                    rowObj.childGrid = childGrid;
                    const modules = childGrid.getInjectedModules();
                    const injectedModues = gObj.getInjectedModules();
                    if (!modules || modules.length !== injectedModues.length) {
                        childGrid.setInjectedModules(injectedModues);
                    }
                    const gridElem = this.parent.createElement('div', {
                        id: 'child' + parents(tr, 'e-grid').length +
                            '_grid' + tr.rowIndex + getUid(''), className: 'e-childgrid'
                    });
                    detailCell.appendChild(gridElem);
                    childGrid.appendTo(gridElem);
                }
                detailRow.appendChild(detailCell);
                if (tr.nextSibling) {
                    tr.parentNode.insertBefore(detailRow, tr.nextSibling);
                }
                else {
                    tr.parentNode.appendChild(detailRow);
                }
                const rowElems = gObj.getRows();
                const rowObjs = gObj.getRowsObject();
                rowElems.splice(rowElems.indexOf(tr) + 1, 0, detailRow);
                if (gObj.enableInfiniteScrolling && gObj.infiniteScrollSettings.enableCache) {
                    const infiniteCache = gObj.contentModule
                        .infiniteCache;
                    const keys = Object.keys(infiniteCache);
                    for (let i = 0; i < keys.length; i++) {
                        const cacheIndex = infiniteCache[parseInt(keys[parseInt(i.toString(), 10)], 10)].indexOf(rowObj);
                        if (cacheIndex !== -1) {
                            infiniteCache[parseInt(keys[parseInt(i.toString(), 10)], 10)].splice(cacheIndex + 1, 0, row);
                            break;
                        }
                    }
                }
                else {
                    rowObjs.splice(rowObjs.indexOf(rowObj) + 1, 0, row);
                }
                if (!isReactCompiler || !isReactChild) {
                    gObj.trigger(events.detailDataBound, { detailElement: detailCell, data: data, childGrid: childGrid });
                }
                gObj.notify(events.detailDataBound, { rows: rowObjs });
            }
            classList(target, ['e-detailrowexpand'], ['e-detailrowcollapse']);
            classList(target.firstElementChild, ['e-dtdiagonaldown', 'e-icon-gdownarrow'], ['e-dtdiagonalright', 'e-icon-grightarrow']);
            rowObj.isExpand = true;
            if (target.classList.contains('e-lastrowcell') && this.parent.getContent().clientHeight > table.scrollHeight) {
                removeClass(target.parentElement.querySelectorAll('td'), 'e-lastrowcell');
                const detailrowIdx = table.querySelector(literals.tbody).getElementsByClassName('e-detailrow').length - 1;
                addClass(table.querySelector(literals.tbody).getElementsByClassName('e-detailrow')[parseInt(detailrowIdx.toString(), 10)].childNodes, ['e-lastrowcell']);
                this.lastrowcell = true;
            }
            this.aria.setExpand(target, true);
            target.firstElementChild.setAttribute('title', this.l10n.getConstant('Expanded'));
        }
        else {
            if (this.isDetailRow(nextRow)) {
                const collapseArgs = { rowData: rowObj.data,
                    parentRow: target.closest('tr'), cancel: false, detailRow: this.isDetailRow(nextRow) ? nextRow : null };
                if (!isNullOrUndefined(event)) {
                    collapseArgs.event = event;
                }
                if (!isNullOrUndefined(gObj.childGrid)) {
                    collapseArgs.childGrid = gObj.childGrid;
                    if (this.isDetailRow(nextRow)) {
                        const gridElement = nextRow.querySelector('.e-grid');
                        collapseArgs.childGridInstance = gridElement ?
                            gridElement.ej2_instances[0] : null;
                    }
                }
                gObj.trigger(events.detailCollapse, collapseArgs);
                if (collapseArgs.cancel) {
                    return;
                }
                nextRow.style.display = 'none';
                gObj.notify(events.detailStateChange, { data: rowObj.data,
                    childGrid: gObj.childGrid, detailElement: target, isExpanded: isExpanded });
            }
            classList(target, ['e-detailrowcollapse'], ['e-detailrowexpand']);
            classList(target.firstElementChild, ['e-dtdiagonalright', 'e-icon-grightarrow'], ['e-dtdiagonaldown', 'e-icon-gdownarrow']);
            if (parseInt(tr.getAttribute(literals.ariaRowIndex), 10) - 1 === lastrowIdx && this.lastrowcell) {
                addClass(target.parentElement.querySelectorAll('td'), 'e-lastrowcell');
                this.lastrowcell = false;
            }
            rowObj.isExpand = false;
            needToRefresh = true;
            this.aria.setExpand(target, false);
            target.firstElementChild.setAttribute('title', this.l10n.getConstant('Collapsed'));
        }
        if (!isNullOrUndefined(gObj.detailTemplate) || (gObj.childGrid && needToRefresh)) {
            gObj.updateVisibleExpandCollapseRows();
            gObj.notify(events.refreshExpandandCollapse, { rows: gObj.getRowsObject() });
        }
        if (this.parent.allowTextWrap && this.parent.height === 'auto') {
            if (this.parent.getContentTable().scrollHeight > this.parent.getContent().clientHeight) {
                this.parent.scrollModule.setPadding();
            }
            else {
                this.parent.scrollModule.removePadding();
            }
        }
    }
    /**
     * @hidden
     * @param {IGrid} gObj - specifies the grid Object
     * @param {Row<Column>}rowObj - specifies the row object
     * @param {string} printMode - specifies the printmode
     * @returns {Object} returns the object
     */
    getGridModel(gObj, rowObj, printMode) {
        let gridModel;
        if (gObj.isPrinting && rowObj.isExpand && gObj.expandedRows &&
            gObj.expandedRows[rowObj.index] && gObj.expandedRows[rowObj.index].gridModel) {
            gObj.expandedRows[rowObj.index].gridModel.hierarchyPrintMode = gObj.childGrid.hierarchyPrintMode;
            gridModel = extend({}, gObj.expandedRows[rowObj.index].gridModel, gObj.childGrid, true);
        }
        else {
            gridModel = extend({}, {}, gObj.childGrid, true);
        }
        if (gObj.isPrinting && gObj.childGrid.allowPaging) {
            gridModel.allowPaging = printMode === 'CurrentPage';
        }
        return gridModel;
    }
    promiseResolve(grid) {
        return () => {
            grid.off(events.contentReady, this.promiseResolve);
            grid.off(events.onEmpty, this.promiseResolve);
            grid.notify(events.hierarchyPrint, {});
        };
    }
    isDetailRow(row) {
        return row && row.classList.contains('e-detailrow');
    }
    destroy() {
        const gridElement = this.parent.element;
        if (this.parent.isDestroyed || !gridElement || (!gridElement.querySelector('.' + literals.gridHeader) &&
            !gridElement.querySelector('.' + literals.gridContent))) {
            return;
        }
        EventHandler.remove(this.parent.element, 'auxclick', this.auxilaryclickHandler);
        this.parent.off(events.click, this.clickHandler);
        this.parent.off(events.destroy, this.destroy);
        this.parent.off(events.keyPressed, this.keyPressHandler);
        this.parent.off(events.expandChildGrid, this.expand);
        this.parent.off(events.columnVisibilityChanged, this.refreshColSpan);
        this.parent.off(events.destroy, this.destroyChildGrids);
        this.parent.off(events.destroyChildGrid, this.destroyChildGrids);
        this.parent.off(events.destroy, this.detachDetailTemplate);
        this.parent.off(events.detachDetailTemplate, this.detachDetailTemplate);
    }
    getTDfromIndex(index, className) {
        const tr = !isNullOrUndefined(index) ? this.parent.getDataRows()[parseInt(index.toString(), 10)] : undefined;
        if (tr && tr.querySelector(className)) {
            return tr.querySelector(className);
        }
        return null;
    }
    /**
     * Expands a detail row with the given target.
     *
     * @param  {Element} target - Defines the collapsed element to expand.
     * @returns {void}
     */
    expand(target) {
        if (!isNaN(target)) {
            target = this.getTDfromIndex(target, '.e-detailrowcollapse');
        }
        if (target && target.classList.contains('e-detailrowcollapse')) {
            this.toogleExpandcollapse(target);
        }
    }
    /**
     * Collapses a detail row with the given target.
     *
     * @param  {Element} target - Defines the expanded element to collapse.
     * @returns {void}
     */
    collapse(target) {
        if (!isNaN(target)) {
            target = this.getTDfromIndex(target, '.e-detailrowexpand');
        }
        if (target && target.classList.contains('e-detailrowexpand')) {
            this.toogleExpandcollapse(target);
        }
    }
    /**
     * Expands all the detail rows of the Grid.
     *
     * @returns {void}
     */
    expandAll() {
        this.expandCollapse(true);
        this.parent.trigger(events.actionComplete, { requestType: 'expandAllComplete', type: events.actionComplete, moduleObj: this });
    }
    /**
     * Collapses all the detail rows of the Grid.
     *
     * @returns {void}
     */
    collapseAll() {
        this.expandCollapse(false);
        this.parent.trigger(events.actionComplete, { requestType: 'collapseAllComplete', type: events.actionComplete, moduleObj: this });
    }
    expandCollapse(isExpand) {
        let td;
        const rows = this.parent.getDataRows();
        for (let i = 0, len = rows.length; i < len; i++) {
            td = rows[parseInt(i.toString(), 10)].querySelector('.e-detailrowcollapse, .e-detailrowexpand');
            if (isExpand) {
                this.expand(td);
            }
            else {
                this.collapse(td);
            }
        }
    }
    keyPressHandler(e) {
        const gObj = this.parent;
        const isMacLike = /(Mac)/i.test(navigator.platform);
        if (isMacLike && e.metaKey) {
            if (e.action === 'downArrow') {
                e.action = 'ctrlDownArrow';
            }
            else if (e.action === 'upArrow') {
                e.action = 'ctrlUpArrow';
            }
        }
        switch (e.action) {
            case 'ctrlDownArrow':
                this.expandAll();
                break;
            case 'ctrlUpArrow':
                this.collapseAll();
                break;
            case 'altUpArrow':
            case 'altDownArrow':
                // eslint-disable-next-line no-case-declarations
                const selected = gObj.allowSelection ? gObj.getSelectedRowIndexes() : [];
                if (selected.length) {
                    const dataRow = gObj.getDataRows()[selected[selected.length - 1]];
                    const td = dataRow.querySelector('.e-detailrowcollapse, .e-detailrowexpand');
                    if (e.action === 'altDownArrow') {
                        this.expand(td);
                    }
                    else {
                        this.collapse(td);
                    }
                }
                break;
            case 'enter':
                if (this.parent.isEdit) {
                    return;
                }
                // eslint-disable-next-line no-case-declarations
                let element = this.focus.getFocusedElement();
                if (element && (element.classList.contains('e-icon-grightarrow') || element.classList.contains('e-icon-gdownarrow'))) {
                    element = element.parentElement;
                }
                if (element && !element.classList.contains('e-detailrowcollapse') &&
                    !element.classList.contains('e-detailrowexpand')) {
                    break;
                }
                this.toogleExpandcollapse(element, e);
                break;
        }
    }
    refreshColSpan() {
        const detailrows = this.parent.contentModule.getTable().querySelectorAll('tr.e-detailrow');
        const colSpan = this.parent.getVisibleColumns().length;
        for (let i = 0; i < detailrows.length; i++) {
            detailrows[parseInt(i.toString(), 10)].querySelector('.e-detailcell').setAttribute('colspan', colSpan + '');
        }
    }
    destroyChildGrids(args) {
        const gObj = this.parent;
        if (gObj.enableInfiniteScrolling && (gObj.childGrid || gObj.detailTemplate) && args.requestType === 'infiniteScroll'
            && gObj.infiniteScrollSettings.enableCache) {
            const cacheIndex = args.direction === 'down'
                ? args.currentPage - gObj.infiniteScrollSettings.initialBlocks
                : args.currentPage + gObj.infiniteScrollSettings.initialBlocks;
            const infiniteCache = gObj.contentModule
                .infiniteCache[parseInt(cacheIndex.toString(), 10)];
            const detailRows = infiniteCache.filter((data) => data.isDetailRow && data.parentUid);
            if (gObj.childGrid) {
                for (let i = 0; i < detailRows.length; i++) {
                    const detailRow = gObj.getContentTable()
                        .querySelector('[data-uid="' + detailRows[parseInt(i.toString(), 10)].uid + '"]');
                    const childGridElement = detailRow.querySelector('.e-childgrid');
                    const childGridIndex = this.childRefs.findIndex((grid) => grid.element.id === childGridElement.id);
                    if (!this.childRefs[parseInt(childGridIndex.toString(), 10)].isDestroyed) {
                        this.childRefs[parseInt(childGridIndex.toString(), 10)].destroy();
                        this.childRefs.splice(childGridIndex, 1);
                    }
                    const detailRowIndex = infiniteCache.indexOf(detailRows[parseInt(i.toString(), 10)]);
                    infiniteCache.splice(detailRowIndex, 1);
                    infiniteCache[detailRowIndex - 1].childGrid = null;
                    infiniteCache[detailRowIndex - 1].isExpand = false;
                    detailRow.remove();
                }
            }
            if (gObj.detailTemplate && detailRows.length) {
                const args = [];
                for (let i = 0; i < detailRows.length; i++) {
                    args.push({
                        detailRow: gObj.getContentTable().querySelector('[data-uid="' + detailRows[parseInt(i.toString(), 10)].uid + '"]'),
                        detailRowObject: detailRows[parseInt(i.toString(), 10)],
                        parentRowObject: infiniteCache.find((parent) => detailRows[parseInt(i.toString(), 10)]
                            .parentUid === parent.uid)
                    });
                }
                this.parent.trigger(events.beforeDetailTemplateDetach, args, () => {
                    for (let i = 0; i < detailRows.length; i++) {
                        const detailRow = gObj.getContentTable()
                            .querySelector('[data-uid="' + detailRows[parseInt(i.toString(), 10)].uid + '"]');
                        const detailRowIndex = infiniteCache.indexOf(detailRows[parseInt(i.toString(), 10)]);
                        infiniteCache.splice(detailRowIndex, 1);
                        infiniteCache[detailRowIndex - 1].isExpand = false;
                        detailRow.remove();
                    }
                });
            }
            return;
        }
        const rows = this.parent.getRowsObject();
        for (let i = 0; i < rows.length; i++) {
            rows[parseInt(i.toString(), 10)].childGrid = null;
        }
        for (let i = 0; i < this.childRefs.length; i++) {
            if (!this.childRefs[parseInt(i.toString(), 10)].isDestroyed) {
                this.childRefs[parseInt(i.toString(), 10)].destroy();
            }
        }
        this.childRefs = [];
    }
    detachDetailTemplate() {
        const gObj = this.parent;
        if (gObj.detailTemplate) {
            const rowsObject = gObj.getRowsObject();
            const detailRows = rowsObject.filter((data) => data.isDetailRow && data.parentUid);
            if (detailRows.length) {
                const args = [];
                detailRows.map((data) => {
                    args.push({
                        detailRow: gObj.getContentTable().querySelector('[data-uid="' + data.uid + '"]'),
                        detailRowObject: data,
                        parentRowObject: rowsObject.find((parent) => data.parentUid === parent.uid)
                    });
                });
                gObj.trigger(events.beforeDetailTemplateDetach, args, () => {
                    detailRows.map((data) => {
                        gObj.getContentTable().querySelector('[data-uid="' + data.uid + '"]').remove();
                    });
                });
            }
        }
    }
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} returns the module name
     * @private
     */
    getModuleName() {
        return 'detailRow';
    }
}
